module.exports = __webpack_public_path__ + "static/media/FrankRuhlLibre_400Regular.43412bd4.ttf";